import { statusSchema } from "@/schema/Status";
import { submittedBySchema } from "@/schema/SubmittedBy";
import { z } from "zod";

export const assessmentProgressSchema = z.object({
  id: z.number(),
  status: statusSchema,
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  company_name: z.string().nullish(),
  submitted_at: z.coerce.date().nullish(),
  submitted_by: submittedBySchema.nullish(),
  issued_at: z.coerce.date().nullish(),
  has_first_evaluation_report: z.coerce.boolean(),
  has_second_evaluation_report: z.coerce.boolean(),
  has_improvement_proposal: z.coerce.boolean(),
  score: z.number().nullish(),
  updated_at: z.coerce.date(),
});

export const appAssessmentProgressSchema = assessmentProgressSchema.omit({
  company_name: true,
});

export type AssessmentProgress = z.infer<typeof assessmentProgressSchema>;
export type AppAssessmentProgress = z.infer<typeof appAssessmentProgressSchema>;
